import { render } from "./GroupSelections.vue?vue&type=template&id=3e15567a&scoped=true&ts=true"
import script from "./GroupSelections.vue?vue&type=script&lang=ts"
export * from "./GroupSelections.vue?vue&type=script&lang=ts"

import "./GroupSelections.vue?vue&type=style&index=0&id=3e15567a&scoped=true&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e15567a"]])

export default __exports__